import { useMemo } from "react";
import { useSelector } from "react-redux";
import { DeviceType } from "../../redux/devices";
import { residentActiveBasedonDevicesCreator } from "../../redux/devicesStatuses/selectors";
import { DeviceMinimizedMap } from "../../redux/residents";
import { IAppState } from "../../redux/types";
import { RoleType } from "../../redux/users";

export const getRoomBed = (devicesMinimized: DeviceMinimizedMap): string => {
  if (!devicesMinimized) return undefined;
  const vitalID = Object.keys(devicesMinimized).find(
    (el) => devicesMinimized[el].type === DeviceType.vitals
  );
  if (
    devicesMinimized[vitalID] &&
    devicesMinimized[vitalID] &&
    devicesMinimized[vitalID]?.room
  )
    return devicesMinimized[vitalID].room + "-" + devicesMinimized[vitalID].bed;
  return "";
};
export const OverflowTip = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}): JSX.Element => {
  // Create Ref

  return (
    <div className={`truncated-text ${className ? className : ""}`}>{text}</div>
  );
};

export const DisplayUserInvisibleContainer = ({
  children,
}: {
  children: any;
}): JSX.Element => {
  const role = useSelector((state: IAppState) => state.userProfile.roleName);
  if (role === RoleType.DISPLAY) return null;

  return children;
};

export const ViewerInvisibleContainer = ({
  children,
}: {
  children: any;
}): JSX.Element => {
  const role = useSelector((state: IAppState) => state.userProfile.roleName);
  const { socketsWorking } = useSelector(
    (state: IAppState) => state.healthCheck
  );
  if (socketsWorking === false || role === RoleType.VIEWER) return null;

  return children;
};

export const RoomBedDisplayByMin = ({
  devicesMinimized,
  isActive,
}: {
  devicesMinimized: DeviceMinimizedMap;
  isActive?: boolean;
}): JSX.Element => {
  const vitalID = Object.keys(devicesMinimized).find(
    (el) => devicesMinimized[el].type === DeviceType.vitals
  );

  return vitalID && devicesMinimized[vitalID]?.room ? (
    <span>{`${
      devicesMinimized[vitalID] ? devicesMinimized[vitalID].room : ""
    }-${devicesMinimized[vitalID] ? devicesMinimized[vitalID].bed : ""}`}</span>
  ) : isActive ? (
    <></>
  ) : // <span>—</span>
  null;
};

export const capitalize = (str: string): string => {
  return str ? str.slice(0, 1).toUpperCase() + str.slice(1) : "";
};
export const processAlertFeedback = (str: string): string => {
  return str ? capitalize(str.replace(/’/g, "'").replace(/\./g, "")) : "";
};

export const MarkForResidentActivityStatus = ({
  devices,
}: {
  devices: DeviceMinimizedMap;
}): JSX.Element => {
  const selection = useMemo(() => residentActiveBasedonDevicesCreator(), []);
  const activeStatus = useSelector((state: IAppState) =>
    selection(state, Object.keys(devices))
  );
  if (Object.keys(devices).length === 0) return null;
  return (
    <div className="status-holder">
      {activeStatus ? (
        <i className="icon-status-online">
          <span className="path1"></span>
          <span className="path2"></span>
        </i>
      ) : (
        <i className="icon-status-offline">
          <span className="path1"></span>
          <span className="path2"></span>
        </i>
      )}
    </div>
  );
};
